import {PAYMENT_DIRECTORY_PAGES,PAYMENT_METHODS,paymentPageBreadcrumbs,paymentMethodPath} from './payment-method-catalog.js';

export function paymentPageMetadata(path:string,origin:string){
  const page=PAYMENT_DIRECTORY_PAGES.find(item=>item.path===path);
  if(!page)return null;
  const url=new URL(path,origin).href;
  const method=PAYMENT_METHODS.find(item=>paymentMethodPath(item)===path);
  const items=paymentPageBreadcrumbs(path);
  return {...page,url,structuredData:{'@context':'https://schema.org','@graph':[
    {'@type':method?'WebPage':'CollectionPage','@id':url,name:page.title,description:page.description,url,inLanguage:'en',isPartOf:{'@type':'WebSite',name:'EightBots',url:new URL('/',origin).href}},
    {'@type':'BreadcrumbList',itemListElement:items.map((item,index)=>({'@type':'ListItem',position:index+1,name:item.name,item:new URL(item.path,origin).href}))},
  ]}};
}
